<p class="interaction-message touch-message">
  <svg width="16" height="16" viewBox="0 0 16 16">
    <use [attr.xlink:href]="tapIcon"></use>
  </svg>
  {{tapMessage()}}
</p>
<p class="interaction-message click-message">
  <svg width="16" height="16" viewBox="0 0 16 16">
    <use [attr.xlink:href]="clickIcon"></use>
  </svg>
  {{clickMessage()}}
</p>
